import { useParams } from 'react-router';
import { useInfinityRSimSessionHistory } from '../../hooks/useInfinityRSimSessionHistory';
import { useSuspenseQuery } from '@tanstack/react-query';
import { ErrorCodes } from 'common/responseCodes.ts';
import { fetchSimInventoryEntry } from 'simInventory/SimInventoryApi/simInventoryApi.ts';
import { ImsiNotValid } from './erros/ImsiNotValid';
import { useRSimSuspenseQuery } from 'rSimInventory/hooks/useRSimSuspenseQuery';
import { SessionHistoryTable } from 'common/components/SessionHistory/SessionHistoryTable.tsx';

const COLUMNS_COUNT = 16;

export const RSimSessionHistoryTable = () => {
  const { euicc } = useParams();

  const { data: rSimInventory } = useRSimSuspenseQuery(euicc!);

  const rSim = rSimInventory?.items[0];

  const { data: primarySim } = useSuspenseQuery({
    queryKey: ['rSimInventory', rSim?.primaryIccid],
    queryFn: () => (rSim?.primaryIccid ? fetchSimInventoryEntry(rSim?.primaryIccid) : null),
    refetchOnWindowFocus: true,
    retry: (failureCount, error) => {
      if (error instanceof Error && error.message === ErrorCodes.NotFound) {
        return false;
      }

      return failureCount < 3;
    },
  });

  const primarySimImsi = primarySim?.imsi;

  if (!primarySimImsi) {
    throw new ImsiNotValid();
  }

  const { sessionHistory, showLoader, refToLoader, fetchingEnded, isLoading } =
    useInfinityRSimSessionHistory(euicc);

  return (
    <SessionHistoryTable
      columnsCount={COLUMNS_COUNT}
      sessionHistory={sessionHistory}
      showProfile={true}
      primarySimImsi={primarySimImsi}
      showLoader={showLoader}
      refToLoader={refToLoader}
      fetchingEnded={fetchingEnded}
      isLoading={isLoading}
    />
  );
};
